<template>
  <div class="back flex" @click="handleBack">
    <van-icon name="arrow-left" color="#fff" />
  </div>
</template>
<script>
export default {
  methods: {
    handleBack() {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="scss" scoped>
.back {
  position: fixed;
  top: 5px;
  left: 5px;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  font-size: 30px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.van-icon {
  font-size: 14px !important;
}
</style>
